import { Injectable, inject } from '@angular/core';
import { RootState } from '@next/core-lib/app';
import { Store } from '@ngrx/store';
import { map, skipWhile, take } from 'rxjs/operators';
import { getFinalSetupSettings } from 'src/app/settings/store/selectors/setting.selector';

@Injectable({
  providedIn: 'root',
})
export class FinalSetupNavigationService {
  private store = inject<Store<RootState>>(Store);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {}

  public canNavigate() {
    return this.store.select(getFinalSetupSettings).pipe(
      skipWhile((finalSetupSettings) => finalSetupSettings === undefined),
      take(1),
      map((finalSetupSettings) => {
        if (finalSetupSettings) {
          return finalSetupSettings.finalSetup;
        } else {
          return false;
        }
      }),
    );
  }
}
